import Settings from './../settings/Settings'
import settOpts from './sett.js'
import Message from './Message.js'

export default class Cs {
	constructor(settings={}) {
    this.sett = new Settings(settOpts, settings)
    this.messages = []

    let agent = 'unknown'
    try {agent = navigator.userAgent} catch (e) {}
    if(agent.indexOf("unknown") > -1)
      this.sett._set('browser', 'unknown')
    else if(agent.indexOf("Chrome") > -1)
      this.sett._set('browser', 'chrome')
    else if (agent.indexOf("Safari") > -1)
      this.sett._set('browser', 'safari')
    else if (agent.indexOf("Opera") > -1)
      this.sett._set('browser', 'opera')
    else if (agent.indexOf("Firefox") > -1)
      this.sett._set('browser', 'firefox')
    else if (agent.indexOf("MSIE") > -1)
      this.sett._set('browser', 'explorer')
  }
  get length() {
    return this.messages.length
  }
  messageLast() {
    if(!this.length) {
      this.fatal(`Can not get message since list is empty`, 'Cs', 'messageLast')
      return null
    }
    return this.messages[this.length-1]
  }
	fatal(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'fatal'}))
  }
	err(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'err'}))
  }
	warn(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'warn'}))
  }
	res(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'res'}))
  }
	proc(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'proc'}))
  }
  debug(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'debug'}))
  }
  debugCn(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'debugCn'}))
  }
  debugDb(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'debugDb'}))
  }
  debugRb(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'debugRb'}))
  }
  debugSt(txt='', cl='', func='', obj=null) {
    return this.add(Object.assign({txt, cl, func, obj}, {name: 'debugSt'}))
  }
  add(mess={name: 'fatal', txt: '', cl: '', func: '', obj: null}) {
    let message = new Message(Object.assign({app: this.sett.app}, mess))
    if(!this.sett[mess.name])
      return message
    if(mess.name.startsWith('debug') && !this.sett['debug'])
      return message
    this.messages.push(message)
    if(this.sett.lengthMax && this.length >= this.sett.lengthMax)
      this.messages.shift() // TODO! Is it effective???
    if(this.sett.write)
      this.write(message.str())
    return message
  }
  write(txt, obj=null) {
    if(obj &&  obj.str)
        txt+= obj.str()
    if(obj && !obj.str)
        txt+=obj.toString()
    if(this.sett.isPlugin && this.sett.browser == 'chrome')
      chrome.tabs.executeScript({code: 'console.log(`'+txt+'`)'})
    else
      console.log(txt)
  }
}



// WEBPACK FOOTER //
// ./src/cs/Cs.js